export default {
  featuredExperiences: 'Нашите препоръчани преживявания',
  searchAllExperiences: 'Търсене на всички преживявания',
  searchAll: 'Търси всички',
  groupSize: 'Размер на групата',
  eventSize: 'Размер на събитието',
  upTo: 'До',
  whatWeDo: 'Какво ще правим',
  hostedBy: 'Домакин',
  whatsIncluded: 'Какво е включено',
  avail: 'Наличност',
  whereWeAre: 'Къде ще бъдем',
  experienceCalendar: 'Календар на преживяванията',
  experienceCancelled: 'Преживяването е отменено',
  experienceStartingPrice: 'От {{price}}',
  experienceTotalPrice: 'Общо {{price}}',
  at: 'в',
  viewPrivateSessAvailability: 'Вижте наличността на частни сесии',
  selectDuration: 'Продължителност',
  selectStartTime: 'Начален час',
  selectSession: 'Изберете сесия',
  sessionsCount: '{{count}} часа — изберете час',
  noAvailability: 'Няма наличност',
  select: 'Избери',
  slotLeft: '{{remainSlots}} оставащо място',
  slotsLeft: '{{remainSlots}} оставащи места',
  spotsLeft: '{{count}} останали',
  spotsLeftAriaLabel: '{{count}} места останали',
  bookExperience: 'Резервирай преживяване',
  book: 'Резервирай',
  learnMore: 'Научете повече',
  apply: 'Приложи',
  maxPartySizes: 'Максимум {{maxGroupSize}} места на група',
  maxPartySize: 'Максимум {{maxGroupSize}} място на група',
  selectSessionValidation: 'Моля, изберете сесия',
  selectParticipantValidation: 'Моля, изберете участници',
  selectDateValidation: 'Моля, изберете дата',
  reminders: 'Напомняния',
  seeOtherDates: 'Вижте други дати',
  location: 'Местоположение',
  about: 'Относно',
  allExperiences: 'Всички изживявания',
  soldOut: 'Разпродадено',
  addOns: 'Допълнения',
  reviews: 'Отзиви',
  reviewSingular: 'отзив',
  reviewPlural: 'отзиви',
  dateOfExperience: 'Дата на преживяването',
  readLess: 'Прочетете по-малко',
  readMore: 'Прочетете повече',
  seeMore: 'Вижте повече',
  details: 'Детайли',
  durationHour: 'час',
  durationHours: 'часа',
  durationMinutes: 'мин',
  theFollowingVideoDoesNotContainAnyAudio: 'Следното видео не съдържа аудио',
  by: 'От',
  chooseATime: 'Изберете час за {{title}}',
  amenities: 'Удобства',
  ticketSalesOpenIn: 'Продажбата на билети започва след',
  ticketSalesOpen: 'Продажбата на билети е открита',
  ticketSalesCloseIn: 'Продажбата на билети приключва след',
  ticketSalesClose: 'Продажбата на билети приключва',
  ticketSalesClosed: 'Продажбата на билети е приключила',
  comingSoon: 'Очаквайте скоро',
  inPartnershipWith: 'В партньорство с',
  notFoundExperienceTitle: 'Това преживяване вече не е налично',
  notFoundExperienceSubtitle:
    'Може да е било непубликувано или връзката може вече да не е валидна.',
  deadLinkRecoverySubtitle:
    'Открийте други преживявания, които можете да резервирате',
  viewAllExperiences: 'Преглед на всички преживявания',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Спечелете 5 базови точки</strong> за всеки допустим $1 USD, изразходван при влизане в акаунта ви в World of Hyatt за резервация на това преживяване</p>',
      basePoints:
        '<p><strong>Спечелете 10 базови точки</strong> за всеки допустим $1 USD, изразходван при влизане в акаунта ви в World of Hyatt за резервация на това преживяване</p>',
      additionalBonusPoints:
        '<p><strong>Спечелете допълнителни 4 бонус точки</strong> за всеки допустим $1 USD, изразходван при резервация с вашата кредитна карта World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Спечелете до 30% допълнителни бонус точки</strong> в зависимост от вашия статус на ниво</p>',
      payWithPoints:
        '<p><strong>Платете с точки</strong> при резервация на това преживяване</p>',
    },
  },
};
